module.exports = __webpack_public_path__ + "static/media/grafismo-contato.a57cf085.svg";